export default {"src":"/_next/static/media/peaceful-butterfly.colour.656ec550.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};